import {Routes} from '@angular/router';
import {LpLaunchpadPage} from './page/launchpad-page/launchpad.page';
import {LpArticleDetailPage} from './page/article-detail-page/article-detail.page';
import {LpHelpAdminPage} from './page/help-admin-page/help-admin.page';

export function LpSubRoutes(): Routes {

    /**
     * Launchpad routes.
     * path: 'lp/...' => route path 'lp/...'
     *
     * canActivate: MsalGuard is added automatically.
     * component: Must be of type 'Page'.
     */
    const routes = [
        {path: 'lp/launchpad/:moduleAlias', component: LpLaunchpadPage},
        {path: 'lp/article/:slug', component: LpArticleDetailPage},
        {path: 'lp/admin/:moduleAlias', component: LpHelpAdminPage},
    ];

    return routes;
}
